import type { ContentElementPodigeeProps } from '@vgn-medien-holding/vgn-fe-components';

const classProps = {
  root: '',
} as ContentElementPodigeeProps['classProps'];

export default classProps;
